package com.iregained.site.components.sections.distributors.sections

import com.iregained.site.region.Region
import com.iregained.site.region.RegionConfig
import com.iregained.site.utils.Res

data class DistributorData(
    val companyName: String, val address: String, val phone: String, val email: String, val websiteUrl: String
)

data class DistributorLocatorData(
    val heroSectionId: String? = "distributors-hero-section",
    val listSectionId: String? = "distributors-list-section",
    val ctaSectionId: String? = "distributors-cta-section",
    val headline: String,
    val subtitle: String,
    val activeDistributors: List<DistributorData>,

    // CMS Configurables: Assets
    val heroBackgroundImage: String = Res.Images.Resources.BANNER,
    val emptyStateImage: String = Res.Images.Distributors.EMPTY_STATE,

    // CMS Configurables: Tool UI Strings
    val searchPlaceholder: String = "🔍 Search by name or city...",
    val locationsFoundText: String = "Locations Found",
    val noResultsMessage: String = "No distributors found matching your search.",
    val emptyRegionMessage: String = "No local distributors currently registered in this region. Please contact our Global HQ.",

    val emptyStateHeadline: String = "Partner With Us",
    val emptyStateDescription: String = "We don't have an authorized distributor in this region yet. If you are an established MedTech distributor, we would love to connect.",
    val emptyStateButtonText: String = "Apply to be a Distributor",

    // CMS Configurables: Button Strings
    val directionsButtonText: String = "Directions",
    val websiteButtonText: String = "Website",

    // CMS Configurables: CTA Section
    val ctaHeadline: String = "Interested in becoming a distributor?",
    val ctaDescription: String = "We are growing our network. If you are an established MedTech distributor, apply to bring MyHand<sup>®</sup> to your region.",
    val ctaButtonText: String = "Apply to Partner",
    val ctaLink: String = "/contact#contact-patient-form-section"
)

// ==========================================
// REGION SWITCHBOARD
// ==========================================
private val allDistributors = mapOf(
    Region.INDIA to listOf(
//        DistributorData("Neurolife Medical Pvt Ltd", "New Delhi, India", "+91 98765 43210", "", "https://neurolife.in"),
//        DistributorData(
//            "MedTech Solutions India",
//            "Mumbai, Maharashtra, India",
//            "+91 98765 11111",
//            "contact@medtech.in",
//            "https://medtech.in"
//        ),
//        DistributorData(
//            "Southern Medical Devices",
//            "Chennai, Tamil Nadu, India",
//            "+91 98765 22222",
//            "sales@southmed.in",
//            "https://southmed.in"
//        )
    ), Region.US to listOf(
        DistributorData(
            "Performance Health",
            "3333 Finley Road, Suite 575Downers Grove, IL 60515",
            "+1 630 393 6000",
            "CustomerSupport@PerformanceHealth.com",
            "https://www.performancehealth.com/myhand-system-complete"
        ),
//        DistributorData(
//            "West Coast Rehab Supplies",
//            "Los Angeles, CA, USA",
//            "+1 800-555-4321",
//            "info@westcoastrehab.us",
//            "https://westcoastrehab.us"
//        ),
//        DistributorData(
//            "East Coast Med Equip",
//            "New York, NY, USA",
//            "+1 800-555-9876",
//            "sales@eastcoastmed.us",
//            "https://eastcoastmed.us"
//        )
    ), Region.CANADA to listOf(
        DistributorData(
            "UpCare<sup>®</sup> - Empowering Healthcare",
            "150 King Street West Toronto, ON, Canada",
            "",
            "contact@upcarepartners.com",
            "https://upcarepartners.com/workshop-myhand-system/"
        ),
//        DistributorData(
//            "Vancouver Medical Solutions",
//            "Vancouver, BC, Canada",
//            "+1 800-555-1122",
//            "support@vanmed.ca",
//            "https://vanmed.ca"
//        ), DistributorData(
//            "Montreal Health Distributors",
//            "Montreal, QC, Canada",
//            "+1 800-555-3344",
//            "contact@mtlhealth.ca",
//            "https://mtlhealth.ca"
//        )
    )
)

val defaultDistributorData: DistributorLocatorData
    get() {
        val activeRegion = RegionConfig.currentRegion
        val regionalDistributors = allDistributors[activeRegion] ?: emptyList()

        return DistributorLocatorData(
            headline = "Locate an Authorized Partner",
            subtitle = "Connect with our authorized regional partners for clinical evaluation, procurement, and local support",
            activeDistributors = regionalDistributors
        )
    }